Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.UnassignTicketsCheckboxView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/unassign_tickets_checkbox"]

  events:
    "click .unassign-tickets-check": "onUnassignTicketsCheck"

  initialize: (options) ->
    @checkboxID = options.id
    @enabled = false
    super

  render: =>
    @$el.html(@template(checkboxID: @checkboxID, enabled: @enabled))
    @delegateEvents()
    @

  onUnassignTicketsCheck: =>
    @setCheckState(!@enabled)
    @trigger('unassign:tickets:enabled:changed', @enabled)
    @render()

  setCheckState: (state) =>
    @enabled = state

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')
